<div class="flex-direction-column gap-10 align-center width-100">
  <header>
    <img src="../../../assets/icone/loga-sfa-preto.png" class="logo-grupo" alt="Logo">
    <p>Bem-vindo, Parceiro!</p>
  </header>
  <main class="login-form">
    <app-form-field
      class="width-50"
      classe="login"
      type="email"
      placeholder="E-mail"
      iconPrefix="account_circle"
      [value]="login.email"
      (onChangeValue)="login.email = $event"
      (onEnterKey)="logar()">
    </app-form-field>
    <app-form-field
      #senhaField
      class="width-50"
      classe="login"
      type="password"
      placeholder="Senha"
      iconPrefix="lock"
      [isSenha]="true"
      [value]="login.senha"
      (onChangeValue)="login.senha = $event"
      (onEnterKey)="logar()">
    </app-form-field>
    <app-button class="width-50" texto="Entrar" (onClick)="logar()"></app-button>
  </main>
</div>
